import type { CasinoFinanceRow } from "./casinoFinanceColumns";

function escapeCsvCell(value: string | number | undefined): string {
  const s = value === undefined || value === null ? "" : String(value);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

const CSV_COLUMNS: { key: keyof CasinoFinanceRow; header: string }[] = [
  { key: "date", header: "Date" },
  { key: "players", header: "Players" },
  { key: "rounds", header: "Rounds" },
  { key: "turnover", header: "Turnover" },
  { key: "wins", header: "Wins" },
  { key: "rtpPct", header: "RTP %" },
  { key: "avgBet", header: "Avg Bet" },
  { key: "ggr", header: "GGR" },
];

/** Builds CSV for the current table rows (MVP export — no server CSV endpoint). */
export function buildCasinoFinanceTableCsv(rows: CasinoFinanceRow[]): string {
  const headerLine = CSV_COLUMNS.map((c) => c.header).join(",");
  const lines = [headerLine];
  for (const r of rows) {
    lines.push(
      CSV_COLUMNS.map((c) => escapeCsvCell(r[c.key] as string | number)).join(","),
    );
  }
  return lines.join("\n");
}
